import { convertIntoDashUSFormat } from "utilities/dateUtility";
import { DefaultColumnOptions } from "hooks/useDataGrid/options";
import K from "utilities/constants";

export const Columns = [
  DefaultColumnOptions.Id,
  {
    headerName: "Milestone Date",
    field: "milestoneDate",
    sort: "asc",
    headerTooltip: "Milestone Date",
    valueGetter: ({ data }) =>
      convertIntoDashUSFormat(data.milestoneDate, false),
    tooltipValueGetter: ({ value }) => value,
  },
  {
    headerName: "Milestone",
    field: "milestoneName",
  },
  {
    headerName: "Status",
    field: "status",
    sortable: true,
    valueGetter: (params) =>
      K.EngagementStatus.byKey(params.data.status)?.label,
    tooltipValueGetter: (params) => params.value,
  },
  {
    headerName: "Client Name",
    field: "clientName",
    tooltipField: "clientName",
    headerTooltip: "Client Name",
  },
  {
    headerName: "Candidate Name",
    field: "candidateName",
    tooltipField: "candidateName",
    headerTooltip: "Candidate Name",
  },
  {
    headerName: "Candidate ATS ID",
    field: "candidateAtsId",
    tooltipField: "candidateAtsId",
    headerTooltip: "Candidate ATS ID",
  },
  {
    headerName: "Department",
    field: "departmentName",
    tooltipField: "departmentName",
  },
  {
    headerName: "Job Title",
    field: "jobTitle",
    tooltipField: "jobTitle",
  },
  {
    headerName: "Start Date",
    field: "startDate",
    valueGetter: ({ data }) => convertIntoDashUSFormat(data.startDate, false),
    tooltipValueGetter: ({ value }) => value,
  },
  {
    headerName: "Recruiters",
    field: "recruiters",
    tooltipField: "recruiters",
    sortable: false,
  },
];
